module.exports = "<table>\n  <thead>\n    <tr>\n      <th class=\"sort\" data-sort=\"name\">name</th>\n      <th class=\"sort\" data-sort=\"age\">age</th>\n      <th>company</th>\n      <th class=\"sort\" data-sort=\"number\">money</th>\n      <th>active</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td class=\"left\">{name}</td>\n      <td style=\"width:30px;\">{age}</td>\n      <td class=\"left\">{company}</td>\n      <td class=\"money\">¥{money | currency 2}</td>\n      <td data-render=\"setActive\" class=\"center\"></td>\n    </tr>\n  </tbody>\n</table>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./example/template/bind.html
 ** module id = 80
 ** module chunks = 0
 **/